<template>
    <span class="radio-wrapper">
        <div class="form-check" v-for="option in field.options" :key="option.id">
            <input
                type="checkbox"
                class="form-check-input"
                :name="field.name"
                :id="option.id"
                :value="option.value"
                v-model="checked"
                v-on:change="$emit('filled-out', checked)"
            >
            <label :for="option.id">{{option.label}}</label>
        </div>
    </span>
</template>

<script>
  import FieldLabel from '../FieldLabel';

  export default {
    props: {
      field: {},
      value: '',
    },
    data() {
      return {
        checked: [],
      };
    },
    components: {
      FieldLabel,
    },
    created() {
      // Make sure default options are selected
      this.addDefaultOptions();
      this.handleBackButton();
    },
    methods: {
      addDefaultOptions() {
        let me = this;
        let emitEvent = false;

        this.field.options.forEach(function(option) {
          if (option.hasOwnProperty("selected") &&
              option.selected === true && 
              !me.checked.includes(option.value)) {
            me.checked.push(option.value);
            emitEvent = true;
          }
        });

        if (emitEvent) {
          this.$emit('filled-out', me.checked);
        }
      },
      // When a customer go back to the page after submitting a form
      // Required checkboxed does not load the checked field and needs to be set by hand
      // This happens cause of the store not binding the value currectly
      handleBackButton() {
        if (this.field.validator.required) {
          let fieldTemp = this.$store.getters.getFieldById(this.field.id);
          if (fieldTemp && typeof fieldTemp.value == 'object' && fieldTemp.value.length > 0) {
            this.checked = fieldTemp.value;
          }
        }
      }
    }
  };
</script>
